// Turns Print Center lines (server print items + quantities) into rendered
// labels with the shared engine — the same template, barcode renderer and
// sheet document the rest of the CMS prints with.

import { buildBarcodeLabelJob } from "../../../components/Print/barcodeLabelJob";
import { normalizeLabelContent } from "../../../components/Print/engine/barcodeLabelTemplate";
import { normalizeSheetGeometry } from "../../../components/Print/engine/sheetLayout";

export const presetGeometry = (preset) => {
  const paper = preset?.config?.paper;
  return normalizeSheetGeometry({
    ...preset?.config?.sheet,
    paperSize: typeof paper === "object" ? paper.size : String(paper || "").toLowerCase(),
    orientation: typeof paper === "object" ? paper.orientation : "portrait",
    paperWidthMM: typeof paper === "object" ? paper.widthMM : 210,
    paperHeightMM: typeof paper === "object" ? paper.heightMM : 297,
  });
};
export const presetContent = (preset) => normalizeLabelContent(preset?.config?.content);

/** @param {Array<{ item: object, quantity: number }>} lines in print order */
export const buildPrintCenterLabelJob = (lines, preset, templateId, qrLinks = {}) =>
  buildBarcodeLabelJob({
    // `qrLinks` maps variantId -> { url } (only used by designs that draw a QR).
    items: lines.map((line) => {
      const qrUrl = qrLinks[line.item.variantId]?.url;
      return { ...line.item, printKey: line.item.key, ...(qrUrl ? { qrUrl } : {}) };
    }),
    copiesByKey: Object.fromEntries(lines.map((line) => [line.item.key, line.quantity])),
    geometry: presetGeometry(preset),
    content: presetContent(preset),
    templateId,
  });

/** What a print attempt records about its layout (stored as-is in the attempt snapshot). */
export const buildAttemptLayout = ({ preset, offsets, templateId }) => ({
  preset: { id: preset.id, name: preset.name, config: preset.config },
  offsets,
  templateId,
});
